import { Avatar, Stack, Typography, Box } from '@mui/material';
import { isDefaultDate } from '../../../utils/common';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import MessageDisplay from '../../Shared/MessageDisplay';

const MemberAvatar = () => {
    const { selectedMember } = useSelector((state: RootState) => state.memberDetail);

    return (
        <Stack direction="row" spacing={2} sx={{ maxWidth: 400, textAlign: 'left', alignItems: 'center', flexWrap: 'nowrap' }}>
            <MessageDisplay />
            <Box sx={{ flex: '0 0 auto' }}>
                <Avatar
                    alt={selectedMember.FirstName + ' ' + selectedMember.LastName}
                    src={selectedMember.ProfileImageUrl}
                    sx={{ width: 80, height: 80 }}
                    className="profile-image"
                />
            </Box>
            <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
                <Typography variant="subtitle2" style={{ marginBottom: '6px' }}>
                    Name: <span className="profile-text">{selectedMember.FirstName + ' ' + selectedMember.LastName}</span>
                </Typography>
                <Typography variant="subtitle2" style={{ marginBottom: '6px' }}>
                    AHCCS Id: <span className="profile-text">{selectedMember.Mem_AHCCCS_ID}</span>
                </Typography>
                <Typography variant="subtitle2" style={{ marginBottom: '6px' }}>
                    DOB: <span className="profile-text">{Boolean(selectedMember.DOB) && !isDefaultDate(selectedMember.DOB) ? new Date(selectedMember.DOB).toLocaleDateString() : ''}</span>
                </Typography>
            </Box>
        </Stack>
    );
};

export default MemberAvatar;
